import {Box, VStack} from 'platform/foundation';

import {useGetCustomerContractBasicInformationQuery} from '@dms/api/customer';

import {TestIdProps, suffixTestId} from 'shared/web';

import {FullScreenModal} from '../FullScreenModal/FullScreenModal';
import {ContractBasicInfoSection} from './components/ContractBasicInfoSection';
import {ContractIndividualPricesSection} from './components/ContractIndividualPricesSection';
import {ContractMaterialDiscountsSection} from './components/ContractMaterialDiscountsSection';
import {ContractWorkDiscountsSection} from './components/ContractWorkDiscountsSection';

interface CustomerContractModalProps extends TestIdProps {
  customerContractId: string;
  onClose: VoidFunction;
}

export function CustomerContractModal(props: CustomerContractModalProps) {
  const {data} = useGetCustomerContractBasicInformationQuery({
    customerContractId: props.customerContractId,
  });

  return (
    <FullScreenModal headline={data?.name ?? undefined} onClose={props.onClose}>
      <Box padding={3}>
        <VStack spacing={3}>
          <ContractBasicInfoSection
            customerContractId={props.customerContractId}
            data-testid={suffixTestId('basicInfo', props)}
          />
          <ContractWorkDiscountsSection
            customerContractId={props.customerContractId}
            data-testid={suffixTestId('workDiscounts', props)}
          />
          <ContractMaterialDiscountsSection
            customerContractId={props.customerContractId}
            data-testid={suffixTestId('materialDiscounts', props)}
          />
          <ContractIndividualPricesSection
            customerContractId={props.customerContractId}
            data-testid={suffixTestId('individualPrices', props)}
          />
        </VStack>
      </Box>
    </FullScreenModal>
  );
}
